/** Eternal City copy, ko. Machine assisted from the English, pending review; proper names and {placeholders} kept as in English. NPC dialogue stays English. */
export const cityKo: Record<string, string> = {
  'city.seoDescription': '살아 있는 도시로 가라. 모든 사람들이 일상적인 일상을 지키고, 그들을 따라가며, 그들과 이야기하며, 당신 없이 살아가고 있는 사람들과 함께 하루를 보내라.',
  'city.intro': '살아 있는 도시입니다. 여기 있는 모든 사람들이 일상적인 일상을 지키고, 여러분이 놀면서 시간이 흐릅니다. 지도를 클릭해서 걷거나 옆에 있는 목록을 사용하세요.',
  'city.back': '지구로 돌아',
  'city.connecting': '도시의 문들을 열고...',
  'city.reconnecting': '밧줄을 잃었어',
  'city.offline': '도시가 지금 접근할 수 없습니다. 잠시 후에 다시 시도해 보시기 바랍니다.',
  'city.signinTitle': '입력하기 위해 로그인',
  'city.signinBody': '도시 에 있는 당신 의 장소, 일기, 그리고 당신이 만난 사람 들 은 당신 의 책 에 저장 되어 있습니다. 당신이 놀면서 시간이 계속 지나가고 있고, 어떤 일들은 기다리지 않습니다.',
  'city.signinCta': '로그인',
  'city.privacy': '우리가 이 데이터를 처리하는 방법: 개인정보 보호정책',
  'city.blocked': '시는 이 계좌를 현재 공개하지 않습니다. 만약 당신이 그것이 실수라고 생각한다면, 지원에 연락하십시오.',
  'city.openElsewhere': '이 도시는 다른 탭에 열려 있습니다. 그 탭을 닫거나 여기에 다시 로드하세요.',
  'city.canvasLabel': '이소메트릭 지도 {city}. 옆에 있는 리스트를 이용해 얘기하고, 걷고, 둘러보세요.',
  'city.hint': '걷기 위해 바닥을 클릭하거나 대화를 하기 위해 사람을 클릭하세요.',
  'city.holiday': '오늘: {name}',
  'city.here': '당신은 {place}에 있습니다.',
  'city.commons.empty': '이 공간은 공유 공간이고, 다른 여행자들은 지금 여기 없습니다.',
  'city.commons.here.one': '이 공간은 공유 공간이고 또 다른 여행자가 여기에 있습니다.',
  'city.commons.here.other': '이 공간은 공유된 공간이고 {count} 다른 여행자들이 여기 있습니다.',
  'city.commons.peer': '동료 여행자',
  'city.crowd.name': '마을 주민',
  'city.travel.ride': '오를 때 {place} (약 {n} 분)',
  'city.wares.now': '이제 설명: {list}',
  'city.wares.none': '이 시간엔 아무것도 없지',
  'city.wares.few': '{name} (몇 분 남았어요)',
  'city.wares.last': '{name} (최후의 것)',
  'city.places': '어딘가에 가',
  'city.goPlace': '가서 {place}',
  'city.dialogueAnnounce': '선택은 그들이 나타난 대로 발표됩니다.',
  'city.people': '누가 주변에 있어?',
  'city.peopleNone': '아무도 보이지 않습니다.',
  'city.talk': '말하라',
  'city.goto': '지나가세요',
  'city.away': '{n} 물러서',
  'city.scenes': '근처에서 벌어지고 있는 일',
  'city.watch': '참여해',
  'city.props': '여기 둘러봐',
  'city.examine': '봐요',
  'city.open': '개방',
  'city.take': '가져와',
  'city.menu.open': '개방 {thing}',
  'city.menu.take': '내 안에 있는 걸 가져가 {thing}',
  'city.menu.walkToThing': '걸어서 {thing}',
  'city.dialogue': '대화',
  'city.close': '가까이',
  'city.leave': '대화는 그만해',
  'city.menu.talk': '{name}와 이야기해',
  'city.menu.walkTalk': '{name}에 걸어가자',
  'city.menu.walkTo': '걸어서 {name}',
  'city.menu.walkHere': '여기 걸어',
  'city.menu.swimHere': '여기 수영해',
  'city.menu.rowHere': '여기 서라',
  'city.mount.down': '{name}에서 내려와',
  'city.companion.home': '보내 {name} 가정',
  'city.rumours.title': '루머 보드',
  'city.rumours.none': '마을 사람들이 함께 얘기하고 있는 곳, 그리고 그들이 말하는 것은 여기 붙어있어요.',
  'city.rumours.said': '말했다 {name}',
  'city.greet.title': '이름으로 알려져 있다',
  'city.greet.callMe': '마을 사람들이 뭐라고 부르죠?',
  'city.greet.placeholder': '네 이름',
  'city.greet.none': '아직 아무도 당신을 몰라요. 누군가와 이야기해 보세요. 다음 번에 그들은 당신을 이름대로 환영합니다.',
  'city.greet.morning.0': '아침, {name}!',
  'city.greet.morning.1': '안녕하세요 {name}.',
  'city.greet.morning.2': '일찍 일어나서 {name}?',
  'city.greet.afternoon.0': '안녕하세요 {name}.',
  'city.greet.afternoon.1': '안녕하세요 {name}!',
  'city.greet.afternoon.2': '다시 만나서 반갑습니다. {name}.',
  'city.greet.evening.0': '저녁, {name}.',
  'city.greet.evening.1': '안녕하세요 {name}!',
  'city.greet.evening.2': '집 밖으로 나가서 {name}?',
  'city.greet.night.0': '출근이 늦었어 {name}.',
  'city.greet.night.1': '어둠을 조심해 {name}.',
  'city.greet.night.2': '아직은 {name}?',
  'city.greet.morning.0.anon': '안녕, 친구!',
  'city.greet.morning.1.anon': '안녕하세요',
  'city.greet.morning.2.anon': '일찍 일어나서?',
  'city.greet.afternoon.0.anon': '안녕하세요, 친구',
  'city.greet.afternoon.1.anon': '안녕하세요!',
  'city.greet.afternoon.2.anon': '다시 만나서 반가워',
  'city.greet.evening.0.anon': '저녁, 친구.',
  'city.greet.evening.1.anon': '안녕하세요!',
  'city.greet.evening.2.anon': '집 밖이야, 친구?',
  'city.greet.night.0.anon': '늦었어, 친구.',
  'city.greet.night.1.anon': '어둠을 조심해',
  'city.greet.night.2.anon': '아직 안 왔어?',
  'city.market.title': '시장판',
  'city.market.shut': '지금엔 아무 것도 없네',
  'city.market.later': '오늘 오후:',
  'city.market.am': '{n} 아침에',
  'city.market.pm': '{n} 오후에 {n}',
  'city.market.eve': '{n} 저녁에 {n}',
  'city.garden.title': '정원 유적',
  'city.garden.tend': '이 줄거리를 돌봐라',
  'city.garden.tended': '몇 가지 풀을 뽑아 토지를 물을 뿌리죠.',
  'city.garden.already': '오늘 이미 이 음모를 처리했군.',
  'city.garden.tendedNote': '오늘',
  'city.garden.arrive': '이 {crop} 여기가 {stage}.',
  'city.garden.crop.herbs': '약초',
  'city.garden.crop.apples': '사과나무',
  'city.garden.crop.kitchen': '부엌 초록색',
  'city.garden.crop.cabbages': '고추와 콩',
  'city.garden.crop.wheat': '밀밭',
  'city.garden.stage.bare': '겨울에 벗겨',
  'city.garden.stage.sown': '새로 심은',
  'city.garden.stage.sprouting': '싹트기',
  'city.garden.stage.growing': '잘 자라는',
  'city.garden.stage.flowering': '꽃으로',
  'city.garden.stage.ripe': '익고 준비된',
  'city.garden.stage.harvested': '연간 수확',
  'city.fish.title': '낚시',
  'city.fish.cast': '줄을 ',
  'city.fish.go': '가자',
  'city.fish.here': '낚시 장소가 좋죠. 판에서 선을 던져보세요.',
  'city.fish.casting': '줄을 서서 기다립니다.',
  'city.fish.caught': '뭔가 물려서 착륙해 {fish}.',
  'city.fish.got.boot': '오래된 보트를 뒤집고 다시 던집니다.',
  'city.fish.got.weed': '이번엔 강초만',
  'city.fish.got.nothing': '물은 비밀만 지킨다',
  'city.fish.casts': '{n} 지금까지 던지는',
  'city.fish.none': '아직 캐스트가 없습니다. 물고기는 새벽과 저녁에 가장 잘 씹고, 봄과 가을에 더 많이 씹습니다.',
  'city.fish.spot.bank': '강변',
  'city.fish.spot.jetty': '제티',
  'city.fish.spot.bridge': '밀 브릿지',
  'city.fish.name.perch': '기둥',
  'city.fish.name.roach': '바퀴벌레',
  'city.fish.name.trout': '오리',
  'city.fish.name.eel': '갈고리',
  'city.fish.name.pike': '파이크',
  'city.fish.name.carp': '카르프',
  'city.fish.name.minnow': '미노우',
  'city.fish.name.crayfish': '개구리',
  'city.fish.name.boot': '오래된 보트',
  'city.fish.name.weed': '강초',
  'city.fish.name.nothing': '아무 것도',
  'city.lost.title': '사라지고 발견된',
  'city.lost.none': '아직 아무것도 발견되지 않았습니다. 시장을, 광장을, 그리고 다른 바쁜 장소에서 물건을 떨어뜨립니다.',
  'city.lost.whose': '소속된 {name}',
  'city.lost.find': '찾아라 {name}',
  'city.lost.spot': '여기 바닥에 뭔가 있어요 {thing}',
  'city.lost.pick': '들어봐 {thing}',
  'city.lost.picked': '네가 들어봐 {thing}. - 이 물건은 {name}.',
  'city.lost.give': '줄게 {thing} 다시 {name}',
  'city.lost.thanks': '{name}은 다시 {thing}를 가지고 기뻐.',
  'city.lost.thing.glove': '잃어버린 장갑',
  'city.lost.thing.keys': '키의 반지',
  'city.lost.thing.locket': '작은 전신',
  'city.lost.thing.toy': '나무 장난감',
  'city.lost.thing.scarf': '털 껍질',
  'city.lost.thing.purse': '빈 지갑',
  'city.lost.thing.spectacles': '안경',
  'city.lost.thing.letter': '접힌 편지',
  'city.lost.thing.ribbon': '머리카락 리본',
  'city.lost.thing.pipe': '진흙 파이프',
  'city.records.title': '도시 기록',
  'city.records.peak': '오늘 가장 바쁜 {time}, {n} 마을 사람들은 여기저기 있습니다.',
  'city.records.now': '이 시간: {out} 밖으로, {home} 집에서요.',
  'city.records.busiest': '가장 바쁜 분기: {district}.',
  'city.records.outTitle': '타운스퍼클은 시간별로',
  'city.records.seenTitle': '당신 주변에서 봤던 사람들, 시간별로',
  'city.a11y.title': '접근성',
  'city.a11y.text': '텍스트 크기는',
  'city.a11y.size1': '정상',
  'city.a11y.size125': '큰',
  'city.a11y.size15': '가장 큰',
  'city.a11y.stillOff': '움직임을 줄이세요',
  'city.a11y.stillOn': '제안은 줄어들었다',
  'city.a11y.contrastOff': '높은 대조성',
  'city.a11y.contrastOn': '높은 대조성',
  'city.tour.welcome.title': '환영합니다 {city}',
  'city.tour.welcome.body': '이 도시는 자신만의 시계를 가지고 살고 있습니다. 사람들은 깨어, 일하고, 먹고, 자고 있습니다.',
  'city.tour.walk.title': '걷는 것',
  'city.tour.walk.body': '모든 열린 땅을 누르면 로봇이 벽과 문을 둘러다니는 길을 찾습니다.',
  'city.tour.talk.title': '대화',
  'city.tour.talk.body': '한 사람 의 이름 을 보기 위해 그 사람 을 누르면 그 사람 에게 다가 가십시오. 가까이 가자면 그 사람 의 말 이 머릿속 에 나타납니다.',
  'city.tour.menu.title': '좀 더 자세히 보고',
  'city.tour.menu.body': '컴퓨터에서 오른쪽 버튼을 누르면 어떤 것도 볼 수 있습니다. 예를 들어, 표지판을 읽어보세요. 앉으세요.',
  'city.tour.map.title': '미니마프',
  'city.tour.map.body': '이 작은 지도는 당신 근처의 도로, 지역 및 사람들을 보여줍니다.',
  'city.tour.panel.title': '당신의 패널',
  'city.tour.panel.body': '옆 패널은 근처에 있는 사람들, 당신이 발견한 장소, 당신의 임무, 당신의 일기 등등을 나열합니다. 전화기에서, 표시 패널 버튼을 사용하여 열 수 있습니다.',
  'city.tour.keys.title': '이동',
  'city.tour.keys.body': '키보드 버튼은 로봇이 알 수 있는 모든 움직임을 보여줍니다.',
  'city.tour.done.title': '그게 전부야',
  'city.tour.done.body': '즐기세요 {city}. 이 투어를 옆 패널에서 다시 할 수 있습니다.',
  'city.tour.step': '{n}의 {total}',
  'city.tour.next': '다음으로',
  'city.tour.back': '돌아와',
  'city.tour.skip': '투어를 건너뛰어',
  'city.tour.finish': '탐험을 시작하라',
  'city.tour.again': '다시 도시 순회로 가',
  'city.found.title': '발견된 장소',
  'city.found.count': '{n}의 {total}',
  'city.found.none': '여기에 추가할 수 있는 곳으로 들어가세요.',
  'city.found.new': '발견 된 것 {place}',
  'city.board.open': '공중 메모판을 읽어보세요',
  'city.board.hint': '다른 여행자들에 의해 남긴 노트. 단편 한 편을 붙여주세요. 링크가 없습니다.',
  'city.board.placeholder': '다른 사람들이 찾아내기 위해 짧은 메모를 적어라',
  'city.board.pin': '메모를 붙여',
  'city.board.loading': '보드를 읽고...',
  'city.board.by': '{name}, {when}',
  'city.board.remove': '메모를 적어라',
  'city.board.err.signin': '로그인해서 메모를 붙여주세요.',
  'city.board.err.soon': '잠깐만 기다려서 또 다른 메모를 붙여줄게',
  'city.board.err.bad': '메모는 200개의 문자까지의 순수한 텍스트로 링크가 없어야 합니다.',
  'city.board.err.down': '지금 이사회에 연락할 수 없습니다.',
  'city.room.rent': '방 한 방 {place}',
  'city.room.move': '방으로 이동 {place}',
  'city.room.yours': '당신의 방은 {place}',
  'city.room.decorate': '여기 뭔가 놓아',
  'city.room.remove': '- 을 꺼내라 {thing}',
  'city.room.leave': '방 내놔',
  'city.room.full': '방에는 더 많은 공간이 없습니다',
  'city.room.pickTitle': '방을 꾸미세요',
  'city.room.pickHint': '이 곳에 설정하는 것을 선택하세요. 이 장치에 있는 방에서 유지됩니다.',
  'city.room.kind.rug': '섬유한 카펫',
  'city.room.kind.candle': '촛불',
  'city.room.kind.flowers': '꽃의 냄비',
  'city.room.kind.painting': '그림',
  'city.room.kind.plant': '이 된 식물',
  'city.room.kind.chest': '작은 가슴',
  'city.room.kind.lantern': '불꽃',
  'city.room.kind.books': '몇 권의 책',
  'city.busk.lute': '{name} 근처에 밝은 음을 니다',
  'city.busk.fiddle': '{name} 근처에 활기찬 스릴을 사운다',
  'city.busk.pipe': '{name} 근처에 느린 공기가 연주됩니다',
  'city.busk.drum': '{name} 근처에 춤추는',
  'city.tail.label': '다음 {name}',
  'city.tail.title': '꼬리 {name} 하루 종일',
  'city.tail.now': '이제... {activity} 에 {place}',
  'city.tail.unknown': '그들의 계획은 아직 알려지지 않았습니다.',
  'city.tail.next': '다음: {place} 에 {time}, {h} h {m} 분',
  'city.tail.trail': '추적: {places}',
  'city.tail.stop': '따라다니는 걸 그만해',
  'city.pins.add': '스핀을 추가',
  'city.pins.tapMap': '지도를 누르면 핀을 배치 할 수 있습니다',
  'city.pins.walk': '이 톱니에 걸어가',
  'city.pins.note': '{x}, {y}. 에 핑',
  'city.pins.noteLabel': '핑 노트',
  'city.pins.remove': '이 핀을 제거해',
  'city.pins.here': '이 곳을 지도에 꽂아',
  'city.compass.north': '북쪽',
  'city.compass.at': 'x {x}, y {y}, 바닥 {floor}',
  'city.door.prop': '문을 열어 두어',
  'city.door.close': '문이 닫히도록 해',
  'city.door.unlock': '문을 잠그세요',
  'city.door.lock': '문 잠겨',
  'city.books.browse': '래프를 탐색하세요',
  'city.books.shelf': '상자 {place}',
  'city.books.book': '책',
  'city.books.scroll': '스크롤',
  'city.books.prev': '이전',
  'city.books.back': '래프로 돌아가',
  'city.books.next': '다음으로',
  'city.books.page': '{n}의 페이지 {of}',
  'city.sign.readSign': '표지판을 읽어봐',
  'city.sign.readPlaque': '표지판을 읽어보세요',
  'city.sign.sign': '칠한 표지판',
  'city.sign.plaque': '문 옆의 표지판',
  'city.district.entering': '이제 들어갑니다',
  'city.district.riverside': '강변 과 낮은 시장',
  'city.district.sunwalk': '태양보행',
  'city.district.lanes': '레인',
  'city.district.monastery': '수도원',
  'city.district.castle': '성',
  'city.district.drains': '오래된 배수물',
  'city.district.farmlands': '농장 들',
  'city.photo.enter': '사진 모드',
  'city.photo.hint': '사진 모드. 주변을 둘러보기 위해 끌고, 스크린샷을 찍어 보관하세요.',
  'city.photo.leave': '사진 모드를 남겨두세요',
  'city.building.who': '이 곳에서 살고 일하고 있는 {place}',
  'city.building.live': '여기 살고 있어요',
  'city.building.work': '여기 작동합니다',
  'city.building.now': '지금 안에 있어',
  'city.building.rooms': '이 점에 {list}.',
  'city.inspect.about': '에 관한 것 {name}',
  'city.inspect.close': '가까이',
  'city.inspect.unknown': '아무도 당신에게 많은 것을 말할 수 없습니다 {name}.',
  'city.inspect.home': '가정',
  'city.inspect.work': '일',
  'city.inspect.none': '아무도 알 수 없습니다',
  'city.inspect.today': '오늘날',
  'city.inspect.row': '{what}, {place}',
  'city.inspect.follow': '따라가 {name} 하루 종일',
  'city.overlay.label': '지도 표면',
  'city.overlay.crowd': '군중',
  'city.overlay.light': '빛',
  'city.overlay.noise': '소음',
  'city.bar.pop': '{n} 여기 살고',
  'city.bar.out': '{n} 이제 나가',
  'city.bar.season.spring': '봄',
  'city.bar.season.summer': '여름',
  'city.bar.season.autumn': '가을',
  'city.bar.season.winter': '겨울',
  'city.notebook.title': '들었고 배웠다',
  'city.notebook.all': '모두들',
  'city.notebook.heard': '들었어',
  'city.notebook.learned': '배워온 것',
  'city.notebook.search': '메모를 검색해봐',
  'city.notebook.none': '거리에서 듣고 사람들과 이야기해봐',
  'city.ask.title': '주변을 둘러봐',
  'city.ask.pick': '누구를 찾고 있어?',
  'city.ask.ask': '물어봐',
  'city.ask.passerby': '지나가는 사람',
  'city.ask.nobody': '물어볼 만큼 가까이 있는 사람은 없어요 거리에서 누군가를 찾아보세요',
  'city.ask.unseen': '{asker} 본 적이 없습니다 {who} 오늘에 대해요.',
  'city.ask.here': '{asker} 라고 합니다. {who} 가까이 있어 {place}.',
  'city.ask.go': '가서 {who}',
  'city.weather.clear': '깨끗한 하늘',
  'city.weather.cloudy.light': '몇 개의 구름',
  'city.weather.cloudy.heavy': '회색과 구름',
  'city.weather.rain.light': '가벼운 비가',
  'city.weather.rain.heavy': '강렬한 비가',
  'city.weather.fog.light': '아침 안개가',
  'city.weather.fog.heavy': '두꺼운 안개가',
  'city.weather.snow.light': '가벼운 눈이',
  'city.weather.snow.heavy': '무거운 눈',
  'city.lamplighter.name': '램프 라이트',
  'city.lamplighter.lighting': '거리등을 조명하는 것',
  'city.lamplighter.dousing': '거리등을 끄는 것',
  'city.hourglass.title': '모래시계는',
  'city.hourglass.stop': '하루를 멈춰라',
  'city.hourglass.paused': '하루는 멈추지 않습니다.',
  'city.hourglass.resume': '가자',
  'city.seat.bench': '벤치',
  'city.seat.chair': '의자',
  'city.seat.sit': '앉으세요 {what}',
  'city.inside.crate': '상자',
  'city.inside.barrel': '배럴',
  'city.inside.title': '{what} 내부에',
  'city.inside.look': '- 안 봐요 {what}',
  'city.inside.holds': '그것은 {fill}: {list}입니다.',
  'city.factions.title': '도시에서 서 있는',
  'city.factions.wary': '조심해',
  'city.factions.unknown': '알 수 없는',
  'city.factions.noticed': '눈에 띄는 것',
  'city.factions.trusted': '신뢰받는 사람',
  'city.factions.honored': '영광스럽다',
  'city.factions.done': '랜드 완료: {n}.',
  'city.mail.title': '편지',
  'city.mail.none': '아직 편지 없어요',
  'city.mail.from': '이 부분에서 {name}',
  'city.mail.waiting': '답변을 기다리고 있습니다. {names}.',
  'city.mail.nobody': '누군가에게 일 좀 도와줘서 쓸 수 있어',
  'city.mail.write': '편지를 써라',
  'city.mail.to': '누구한테',
  'city.mail.subject': '주제는',
  'city.mail.body': '당신의 편지',
  'city.mail.send': '보내줘',
  'city.mail.untitled': '몇 줄',
  'city.moth.title': '나비의 트레이',
  'city.moth.trade': '제발 부탁해',
  'city.moth.yours': '이제 네 몫이야',
  'city.spy.title': '조용한 작업',
  'city.cut.skip': '스피프',
  'city.party.title': '함께 놀아',
  'city.party.blurb': '파티를 시작해서 친구들과 코드를 공유해 보세요. 그 파티에 참여하는 모든 사람들은 도시 곳곳에서 서로를 볼 수 있습니다.',
  'city.party.start': '파티를 시작해',
  'city.party.codeLabel': '파티 코드',
  'city.party.join': '참여',
  'city.party.bad': '파티 코드는 4~8개의 문자나 숫자입니다.',
  'city.party.code': '당신의 파티 코드는 {code}. 친구들에게 공유해 주세요.',
  'city.party.alone': '당신 파티의 다른 사람은 지금 도시에 없습니다.',
  'city.party.here': '바로 옆에',
  'city.party.away': '{n} 발걸음 {dir}',
  'city.party.floor': '(층 {n})',
  'city.party.go': '가서',
  'city.party.leave': '파티를 떠나',
  'city.party.dir.east': '동쪽',
  'city.party.dir.south-east': '남동쪽',
  'city.party.dir.south': '남쪽',
  'city.party.dir.south-west': '남서쪽',
  'city.party.dir.west': '서부',
  'city.party.dir.north-west': '북서쪽',
  'city.party.dir.north': '북쪽',
  'city.party.dir.north-east': '북동쪽',
  'city.print.title': '건물 을 인쇄',
  'city.print.here': '{name}: {w} 에 의해 {d} 세포, 바닥: {n}. 3D 프린터에 STL로 저장해두세요',
  'city.print.none': '3D 프린터에 STL로 저장하기 위해 건물에 서거나 옆에 서십시오.',
  'city.print.model': 'STL를 저장하고, 모델 스케일 (5mm/세포)',
  'city.print.tabletop': 'STL를 저장, 테이블톱 규모 (세포당 1 인치)',
  'city.print.note': '벽, 바닥, 문, 계단, 창문, 도시가 그림을 그리면서, 원판에 그려서 하나의 조각으로 인쇄합니다.',
  'city.print.models': '인쇄할 준비가 된 그림과 자재:',
  'city.print.busy': '준비해...',
  'city.print.model.figure': '워커 형상, 25mm 기지에 28mm',
  'city.print.model.fountain': '폭 3인치의 분수',
  'city.print.model.castle-wall': '15cm 길이의 성벽 부분',
  'city.editor.stl': 'STL를 저장',
  'city.editor.title': '도시 지도 편집자',
  'city.editor.blurb': '도시 지도 바닥을 층으로 칠합니다. 벽, 거리, 문, 물, 계단 및 이름 지어진 장소. 아래 체크는 거주하는 도시와 동일한 지도 리더를 사용하여 읽습니다. 이 브라우저에서 드래프트를 저장합니다. 보관하거나 공유 할 파일로 수출합니다.',
  'city.editor.name': '지도 이름',
  'city.editor.tools': '도구',
  'city.editor.tool.pen': '펜',
  'city.editor.tool.rect': '블록',
  'city.editor.tool.room': '방',
  'city.editor.tool.fill': '채우기',
  'city.editor.tool.spawn': '출발점',
  'city.editor.tiles': '땅',
  'city.editor.letter': '편지',
  'city.editor.placeName': '장소 이름',
  'city.editor.addPlace': '장소 추가',
  'city.editor.placeBad': '장소는 한 글자와 이름이 필요합니다.',
  'city.editor.floors': '바닥',
  'city.editor.addFloor': '바닥을 추가',
  'city.editor.map': '지도',
  'city.editor.width': '너비',
  'city.editor.height': '높이',
  'city.editor.new': '새로운 지도',
  'city.editor.undo': '무효',
  'city.editor.export': '수출',
  'city.editor.import': '수입',
  'city.editor.loaded': '지도가 가득 차 있습니다.',
  'city.editor.zoom': '확대',
  'city.editor.check': '체크',
  'city.editor.ok': '순수하게 읽습니다. {walk} 개방된 세포, {reach} 출발점부터 접근할 수 있습니다.',
  'city.editor.placeSpots': '{name}: {n} 세포',
  'city.editor.canvas': '지도 캔버스',
  'city.spy.take': '가져와',
  'city.spy.again': '다시 시도해봐',
  'city.spy.drop': '그만해',
  'city.spy.progress': '{n} 그쪽은 100%입니다.',
  'city.spy.carrying': '그 메모는 네 손에 있어요.',
  'city.spy.underway': '가자',
  'city.spy.done': '다 됐어',
  'city.spy.failed': '지난번엔 잘못됐어',
  'city.menu.look': '이봐요 {thing}',
  'city.menu.street': '거리는',
  'city.menu.wall': '벽',
  'city.continue': '계속',
  'city.goodbye': '안녕하세요',
  'city.board.title': '보너스 보드',
  'city.arrive.rooftops': '당신은 지붕에 올라갑니다. 그 아래로 가로로가 열리고, 집들 사이의 보드들은 발 아래로 니다.',
  'city.arrive.museumRoof': '오래된 아이비를 박물관 지붕에 올려놓으면, 선워크 플라자라는 게임보드처럼 아래로 펼쳐집니다.',
  'city.crier.title': '울부짖는 자',
  'city.crier.today': '오늘은 {name}.',
  'city.crier.tomorrow': '{name} 내일이야',
  'city.crier.coming': '{name} 에 {n} 며칠 동안',
  'city.crier.stalls': '새벽에 창고에서:',
  'city.crier.notices': '{n} 보너스 게시판에 알림이 있습니다.',
  'city.crier.talk': '마을에 대해 얘기하자면',
  'city.crier.now': '지금 이 시내에서 벌어지고 있는 일이죠.',
  'city.board.empty': '오늘 아무것도 안 됐어 내일 다시 확인해',
  'city.board.posted': '게시된: {name}.',
  'city.board.postedAt': '{name}, 에 의해 게시, 현재 {place}.',
  'city.board.days': '{n} 며칠 남았어요',
  'city.board.find': '찾아봐',
  'city.topics.ask': '{word}?',
  'city.talkWith': '{name}와 대화하고 있어요',
  'city.journal': '일간지',
  'city.journalNone': '아직 아무것도 적혀 있지',
  'city.quests': '과 스레드',
  'city.questNone': '아직 없네, 사람들과 얘기해',
  'city.rest': '휴식 {n} 분',
  'city.saves.title': '저장된 게임',
  'city.saves.slot': '슬롯 {n}: {day} {time}, {place}',
  'city.saves.empty': '슬롯 {n}: 빈',
  'city.saves.save': '여기 저장해',
  'city.saves.load': '부하',
  'city.saves.sure': '확인하기 위해 다시 누르세요',
  'city.saves.hint': '세이브는 도시 전체를 그대로 유지합니다. 당신이 어디에 있는지, 시간, 사람들, 퀘스트와 가슴.',
  'city.restHint': '시간이 지나면 한 시간 동안만 쉬게 될 거야',
  'city.bed.ask': '잠들게 {bed}?',
  'city.bed.night': '8시간이 지나면 잠을 잘 수 있고, 게임 시스템의 규칙에 따라 휴식을 취합니다.',
  'city.bed.sleep': '잠들기',
  'city.bed.notNow': '지금은 안 돼',
  'city.bed.tired': '아직 피곤하지 않아서 다시 잠들 수 있을 거야 {n} 몇 시간 동안',
  'city.bed.asleep': '잠들어, 밤이 지나고...',
  'city.bed.offer': '여기서 자',
  'city.vitals': '건강',
  'city.bed.woke': '잠들게 {bed} 그리고 일어나서 {time}. {change}',
  'city.bed.change': '{label}: {before} 에 대한 {after}.',
  'city.bed.noRest': '이 {system} 규칙은 휴식을 위한 회복을 제공하지 않으므로 아무것도 치유되지 않습니다.',
  'city.bed.beds': '침대',
  'city.bed.demoRules': '침대 테스트 규칙: {system}. - 더나 쥐를 더해 다른 주소를 시도해봐',
  'city.messages': '노트',
  'city.rules': '게임 시스템',
  'city.rulesNarrative': '규칙이 없습니다. 도시가 하나의 이야기입니다. 모든 사람들을 그 숫자로 볼 수 있는 시스템을 선택하세요.',
  'city.statsFor': '숫자는',
  'city.sparTitle': '연습 경기가',
  'city.sparA': '첫 전투기',
  'city.sparB': '제2 전투기',
  'city.sparVs': '반대',
  'city.sparRun': '싸움',
  'city.sparNote': '이 시스템에서 시위가 벌어지고 도시에서는 아무도 다치지 않습니다.',
  'city.sparRound': '둥근 {n}.',
  'city.zoomIn': '확대',
  'city.pivot.left': '시점을 왼쪽으로 회전',
  'city.pivot.right': '시점을 오른쪽으로 회전',
  'city.pivot.north': '북쪽 보기',
  'city.zoomOut': '줌 아웃',
  'city.centre': '나를 중심으로',
  'city.followOn': '계속해',
  'city.followOff': '따라와',
  'city.followOnHint': '카메라가 당신을 추적하고, 자유롭게 꺼내야 합니다.',
  'city.followOffHint': '어디든 아 아 날 만져서 다시 돌아와',
  'city.minimapShow': '지도 보기',
  'city.minimapHide': '지도 숨기기',
  'city.minimapOpen': '도시 지도를 눌러서 더 크게 열죠.',
  'city.minimapWalk': '도시 지도, 걸어갈 수 있는 곳을 눌러보세요.',
  'city.minimapSmall': '지도 작게 보기',
  'city.minimapHint': '거기 걸을 수 있도록 탭',
  'city.chatter.morning.1.a': '서두르면 구석에서 신선한 빵을 먹으세요.',
  'city.chatter.morning.1.b': '두 거리에서 냄새를 맡았어요',
  'city.chatter.morning.2.a': '일찍 일어나서',
  'city.chatter.morning.2.b': '벨은 날 깨우쳤어 항상 깨우치고 있어',
  'city.chatter.morning.3.a': '바퀴가 게이트를 통해 들어왔나요?',
  'city.chatter.morning.3.b': '세명, 그리고 한 명은 다리에서 바퀴를 잃었습니다.',
  'city.chatter.morning.4.a': '오늘 아침 추워요',
  'city.chatter.morning.4.b': '강 안개가 낮에 사라질 것입니다.',
  'city.chatter.morning.5.a': '어디로 가시죠?',
  'city.chatter.morning.5.b': '좋은 사과가 없어지기 전에 시장에',
  'city.chatter.afternoon.1.a': '창고에서 바쁜 날입니다.',
  'city.chatter.afternoon.1.b': '너무 바쁘다, 내 발은 내 걸 포기했어',
  'city.chatter.afternoon.2.a': '오늘 을 봤어?',
  'city.chatter.afternoon.2.b': '한 시간 전에 물로 내려갔어요',
  'city.chatter.afternoon.3.a': '오늘 햇빛은 친절합니다.',
  'city.chatter.afternoon.3.b': '비가 오고 있어 무릎에 느껴요',
  'city.chatter.afternoon.4.a': '물고기 매매가 개구리에게 무엇을 원했나요?',
  'city.chatter.afternoon.4.b': '너무 많았어요. 그 대신 쌀을 샀어요.',
  'city.chatter.afternoon.5.a': '새 바퀴야?',
  'city.chatter.afternoon.5.b': '새게, 바퀴는 여전히 옛바퀴처럼 울고 있습니다.',
  'city.chatter.evening.1.a': '집에 가고 있어?',
  'city.chatter.evening.1.b': '저녁 식사는 스스로 요리할 수 없습니다.',
  'city.chatter.evening.2.a': '램프가 켜지고 있어요',
  'city.chatter.evening.2.b': '다시 늦었어',
  'city.chatter.evening.3.a': '오늘 밤 술집에 있을 거야?',
  'city.chatter.evening.3.b': '아내가 허락하면 그래',
  'city.chatter.evening.4.a': '긴 날',
  'city.chatter.evening.4.b': '모두 그렇죠. 올해로요.',
  'city.chatter.evening.5.a': '오늘 밤 잠금을 닫아',
  'city.chatter.evening.5.b': '항상 그래요. 바람은 어차피 흔들립니다.',
  'city.chatter.night.1.a': '누가 거기 갔어요?',
  'city.chatter.night.1.b': '저만 램퍼트 내려놔',
  'city.chatter.night.2.a': '자고 있어야지',
  'city.chatter.night.2.b': '너도 그럴 거야 친구',
  'city.chatter.night.3.a': '물 근처에서 무슨 소리 들었어?',
  'city.chatter.night.3.b': '고양이는 항상 고양이야',
  'city.chatter.night.4.a': '조용한 밤',
  'city.chatter.night.4.b': '그렇게 계속해 보자',
  'city.chatter.any.1.a': '뉴스를 들었어?',
  'city.chatter.any.1.b': '어떤 소식이? 항상 뉴스가 있습니다.',
  'city.chatter.any.2.a': '안녕하세요',
  'city.chatter.any.2.b': '그리고 너한테도',
  'city.chatter.any.3.a': '내 사촌은 오래된 탑이 유령이 있다고 맹세합니다.',
  'city.chatter.any.3.b': '네 사촌은 많은 것을 맹세합니다.',
  'city.chatter.any.4.a': '가격은 계속 상승합니다.',
  'city.chatter.any.4.b': '그리고 내 급여는 멈추지 않는다.',
  'city.chatter.any.5.a': '저 웅덩이에 조심해',
  'city.chatter.any.5.b': '너무 늦었어, 어쨌든 고마워요',
  'city.chatter.any.6.a': '다들 언급하는 이 낯선 사람이야?',
  'city.chatter.any.6.b': '쳐다보지 마, 무례하다.',
  'city.chatter.any.7.a': '엄마 어때요?',
  'city.chatter.any.7.b': '더 좋아, 고마워요, 다시 날 꾸짖는 거야',
  'city.chatter.any.8.a': '술 한 잔 줘야 해?',
  'city.chatter.any.8.b': '두 번째, 내 계산에 따르면.',
  'city.inventory.title': '짐을 챙겨',
  'city.inventory.subtitle': 'Montkelian 주머니',
  'city.inventory.close': '짐을 닫아',
  'city.inventory.tabs': '패키지 섹션',
  'city.inventory.tab.inventory': '수록물',
  'city.inventory.tab.journal': '일간지',
  'city.inventory.tab.map': '지도',
  'city.inventory.empty': '여행 중에 발견한 물건들은 이 주머니에 보관될 겁니다.',
  'city.inventory.slots': '주머니',
  'city.inventory.slotEmpty': '주머니 {n}, 빈',
  'city.inventory.slot.headgear': '머신장',
  'city.inventory.slot.helmet': '헬멧',
  'city.inventory.slot.hat': '모자',
  'city.inventory.slot.hood': '호드',
  'city.inventory.slot.amulet': '아뮬렛',
  'city.inventory.slot.cloak': '옷장',
  'city.inventory.slot.tabard': '타버드',
  'city.inventory.slot.pelt': '가죽',
  'city.inventory.slot.armor': '장갑',
  'city.inventory.slot.plate': '접시',
  'city.inventory.slot.robe': '의복',
  'city.inventory.slot.jerkin': '젠장',
  'city.inventory.slot.hide': '숨기기',
  'city.inventory.slot.girdle': '빗자루',
  'city.inventory.slot.belt': '벨트',
  'city.inventory.slot.bracers': '브레이커',
  'city.inventory.slot.gloves': '장갑',
  'city.inventory.slot.mainHand': '주 손',
  'city.inventory.slot.offHand': '손에서 벗어난 것',
  'city.inventory.slot.twoHand': '두 손 다',
  'city.inventory.slot.sword': '검',
  'city.inventory.slot.shield': '방패',
  'city.inventory.slot.staff': '직원',
  'city.inventory.slot.focus': '집중하라',
  'city.inventory.slot.ring': '반지',
  'city.inventory.slot.leggings': '가구',
  'city.inventory.slot.greaves': '그레이브',
  'city.inventory.slot.boots': '부츠',
  'city.inventory.item.sword': '검',
  'city.inventory.item.shield': '방패',
  'city.inventory.item.knife': '칼',
  'city.inventory.item.axe': 'Axe',
  'city.inventory.item.tabard': '타버드',
  'city.inventory.item.cape': '케이프',
  'city.inventory.item.ring': '반지',
  'city.inventory.class.default': '여행자',
  'city.inventory.class.fighter': '전투기',
  'city.inventory.class.paladin': '팔라딘',
  'city.inventory.class.berserker': '베르서커',
  'city.inventory.class.wizard': '마법사',
  'city.inventory.class.rogue': '악당',
  'city.inventory.slotFree': '공허',
  'city.inventory.gear': '당신이 입는 옷',
  'city.inventory.view': '쇼',
  'city.inventory.viewGear': '착용',
  'city.inventory.viewPockets': '주머니',
  'city.inventory.avatarHint': '메뉴에서 다른 아바타를 선택하세요',
  'city.inventory.soon.journal': '네 일기에는 아직 아무것도 없습니다.',
  'city.inventory.soon.map': '이 종이접힌 지도는 여기 보관되어 있고, 당신이 다녀온 장소가 표시됩니다.',
  'city.inventory.hint': '팩을 열기 위해 자신을 눌러',
  'city.avatar': '아바타르',
  'city.avatarLabel': '아바타를 선택하세요',
  'city.avatar.robot': '로봇',
  'city.avatar.nycanthea': 'Nycanthea',
  'city.avatar.paladin': '팔라딘',
  'city.avatarCloth': '옷',
  'city.avatarClothHint': '뚜과 타바드는 움직일 때 흔들립니다',
  'city.soundOn': '음향을 켜',
  'city.soundOff': '음향을 끄세요',
  'city.musicOn': '음악 연주',
  'city.musicOff': '음악은 멈춰',
  'city.walkSpeed': '속도',
  'city.walkSpeedLabel': '걷기 속도는',
  'city.walkSpeedValue': '{n}x',
  'city.me': '나',
  'city.quality': '품질',
  'city.qualityAuto': '자동 ({tier})',
  'city.tier.low': '낮은',
  'city.tier.medium': '중간',
  'city.tier.high': '높은',
  'city.robot.keys': '로봇 키',
  'city.robot.title': '로봇 키',
  'city.robot.intro': '키를 누르거나 여기 누르면 로봇은 주변 사람들이 볼 수 있도록 작동합니다. 그것은 쇼를 위한 것 뿐이고 게임에 아무런 변화를 일으키지 않습니다.',
  'city.robot.close': '가까이',
  'city.robot.jumpNote': '공중에 있는 동안 다시 스페이스를 누르면 두 배로 점프할 수 있습니다.',
  'city.robot.spellNote': '매술 모드에서는 공격 대신 1, 2 및 3을 던집니다. 매술은 빠르게, 매술은 먼저 충전됩니다.',
  'city.robot.climbNote': '가장 가까운 계단, 계단, 이브리 또는 드레인 파이프에 올라갈 수 있습니다.',
  'city.robot.walkNote': 'W, A, S, D는 북쪽, 서쪽, 남쪽, 동쪽을 한 걸음씩 걷습니다. 계속 걷기 위해 키를 들고 있습니다. 화살표 키는 똑같이합니다.',
  'city.robot.walk.north': '북쪽으로 걸어',
  'city.robot.walk.west': '서쪽으로 걸어',
  'city.robot.walk.south': '남쪽으로 걸어',
  'city.robot.walk.east': '동쪽으로 걸어',
  'city.stairs.label': '계단을 타고',
  'city.stairs.up': '위로',
  'city.stairs.down': '아래로',
  'city.stairs.goUp': '바닥에 올라가서',
  'city.stairs.goDown': '바닥으로 내려가',
  'city.robot.toggleNote': '무기 모드, 주문 모드, 스닉, 댄스, 하트다운은 다시 누릴 때까지 계속하세요.',
  'city.robot.typing': '키는 당신이 상자에 입력하는 동안 아무것도 하지 않습니다.',
  'city.robot.inSpell': '마법 모드: {act}',
  'city.robot.otherwise': '그렇지 않으면: {act}',
  'city.robot.pad': '행동',
  'city.robot.padShow': '액션 패드를 표시',
  'city.robot.padHide': '액션 패드를 숨기',
  'city.robot.padTouch': '(터치 스크린)',
  'city.robot.noLadder': '근처에 계단이나 계단이 없습니다.',
  'city.robot.act.jump': '점프',
  'city.robot.act.double-jump': '이중 점프',
  'city.robot.act.dodge': '도지',
  'city.robot.act.block': '차단하거나 방어',
  'city.robot.act.parry': '파리',
  'city.robot.act.weapon-mode': '무기 모드',
  'city.robot.act.spell-mode': '주문 모드',
  'city.robot.act.slash': '썰매',
  'city.robot.act.thrust': '추진력',
  'city.robot.act.flurry': '어',
  'city.robot.act.cast': '캐스팅',
  'city.robot.act.cast-spell': '캐스팅 마술',
  'city.robot.act.megacast': '메가캐스트',
  'city.robot.act.duck': 'Duck',
  'city.robot.act.sneak': '속임수',
  'city.robot.act.sing': '노래하라',
  'city.robot.act.dance': '춤을 추는 것',
  'city.robot.act.barf': '콧수염',
  'city.robot.act.fall': '떨어지거나 일어서',
  'city.robot.act.climb-up': '올라와',
  'city.robot.act.climb-down': '내려가',
  'city.robot.act.hurt': '쏴봐',
  'city.robot.act.kneel': '무릎을 꿇고 일어서',
  'city.robot.act.bow': ' Bow',
  'city.robot.act.cheer': '승리에 환호',
  'city.panelShow': '표시 패널',
  'city.phone.menu': '메뉴',
  'city.phone.close': '메뉴를 닫는다',
  'city.phone.view': '지도',
  'city.phone.sound': '음향과 속도',
  'city.phone.people': '누군가를 찾아',
  'city.phone.more': '다른 모든 것',
  'city.phone.hint': '걷기 위해 바닥을 밟아, 말을 하기 위해 사람을 밟아.',
  'city.phone.gotIt': '알았어',
  'city.panelHide': '숨겨진 패널',
  'city.canvasLabel3d': '지도 {city} 위에서 각도로 볼 수 있습니다. 주변을 둘러보기 위해 끌고, 확대하기 위해 거나 스크롤, 걷기 위해 탭하거나 이야기하기 위해. 패널은 모든 사람과 모든 것을 여기에 나열합니다.',
  'city.dock.label': '찾아볼 수 있는 사람들',
  'city.dock.go': '걸어서 {name}',
  'city.dock.walking': '걸어서 {name}',
  'city.dock.toPlace': '{name}에서 {place}로 걷고',
  'city.dock.cancel': '멈출 수 있도록 바닥에 눌러',
  'city.rigDebug.open': '어떻게 디버깅 할 수 있는지 {name} 움직인다',
  'city.rigDebug.title': '리그 디버깅: {name}',
  'city.rigDebug.close': '가까이',
  'city.rigDebug.move': '움직여',
  'city.rigDebug.facing': '마주보고',
  'city.rigDebug.allMoves': '모든 움직임',
  'city.rigDebug.allFacings': '모든 면',
  'city.rigDebug.cycling': '사이클링, {s}s 각각',
  'city.rigDebug.play': '놀아',
  'city.rigDebug.pause': '휴식',
  'city.rigDebug.back': '한 프레임 뒤로 물러서',
  'city.rigDebug.forward': '한 단계 앞으로 한 프레임',
  'city.rigDebug.speed': '속도',
  'city.rigDebug.hint': '프레임에 따라 단계로 잠시 멈추고 밖으로 누르거나 Escape를 누르면 닫습니다.',
  'city.rigDebug.anim.idle': '비활성',
  'city.rigDebug.anim.walk': '걷기',
  'city.rigDebug.debug': '디버깅',
  'city.rigDebug.viewLabel': '뷰',
  'city.rigDebug.view.2d': '2D',
  'city.rigDebug.view.iso': '이소메트릭',
  'city.rigDebug.view.3d': '3D',
  'city.rigDebug.facingIs': '앞면 {dir}',
  'city.rigDebug.cell': '라인 {row}, 프레임 {col}',
  'city.rigDebug.loading': '로딩',
  'city.rigDebug.clip': '클립',
  'city.rigDebug.allClips': '모든 클립',
  'city.rigDebug.noClips': '클립이 없습니다',
  'city.rigDebug.layers': '쇼',
  'city.rigDebug.show.model': '모델',
  'city.rigDebug.show.bones': '뼈',
  'city.rigDebug.show.pieces': '조각',
  'city.rigDebug.boneCount': '{n} 뼈',
  'city.rigDebug.no3d': '3D 뷰는 이 화면에서 시작될 수 없었습니다.',
  'city.rigDebug.hint3d': '카메라를 돌리기 위해 끌고, 프레임에 따라 단계적으로 멈추고, 밖으로 누르거나,',
  'city.rigDebug.standIn': '{name}는 그녀의 자신의 준비가 될 때까지 {body}에 표시됩니다.',
  'city.rigDebug.archive': '아카이브',
  'city.rigDebug.archivePose': '포즈를 미리보기: 어떻게 하는지 보세요 {name} 움직인다',
  'city.pose.open': '어떻게 하는지 알아봐 {name} 움직인다',
  'city.pose.robot': '당신 (로봇 서트인)',
  'city.pose.you': '당신',
  'city.pose.see': '움직임을 보아라',
  'city.pose.youTitle': '어떻게 움직이는지',
  'city.pose.openYou': '어떻게 움직인지는 봐',
  'city.pose.title': '어떻게 {name} 움직인다',
  'city.pose.allTitle': '모든 자세',
  'city.pose.all': '모든 자세를 보여줘',
  'city.pose.one': '그냥 {name}',
  'city.pose.close': '가까이',
  'city.pose.hint': '닫기 위해 바깥에 누르세요',
  'city.pose.loading': '로딩',
  'city.pose.anim.idle': '비활성',
  'city.pose.anim.walk': '걷기',
  'city.pose.anim.talk': '말하라',
  'city.pose.anim.sit': '앉으세요',
  'city.pose.anim.run': '도망쳐',
  'city.pose.drag': '끌고 회전',
  'city.pose.gait': '운동',
  'city.pose.model': '{name} 3D',
  'city.pose.dir.SW': '남서쪽으로 향하는',
  'city.pose.dir.SE': '동남쪽으로 향하는',
  'city.pose.dir.NE': '북동쪽으로 향하는',
  'city.pose.dir.NW': '북서쪽으로 향하는',
  'city.demoLink': '렌더링 데모를 열',
  'city.demoTitle': '렌더러 데모',
  'city.demoNote': '3D 시티의 지역 미리보기, 스탠드인 워커들, 여기서 게임 서버와 대화하는 게 없습니다.',
  'city.demoTime': '낮 시간',
  'city.demoSeason': '계절',
  'city.demoPlay': '시계를 실행하라',
  'city.demoPause': '시계를 멈춰라',
  'city.demoTower': '테스트 타워',
  'city.demoTowerNote': '4층 건물 은 실내 에서 볼 수 있는 것 을 확인 하기 위한 건물 이다. 내부 에, 당신 의 위층 이 잘라져 있고, 당신 의 서 있는 곳 에서 볼 수 없는 모든 것 은 회색 으로 드러나 있다.',
  'city.demoGoTower': '탑으로 걸어 가',
  'city.demoFloor': '바닥: {floor}',
  'city.demoFloor0': '땅',
  'city.demoFloor1': '2번째',
  'city.demoFloor2': '제3회',
  'city.demoFloor3': '4번째',
  'city.demoFloor4': '지붕',
  'city.demoWindow': '3층 창',
  'city.demoRoom': '3층 내실',
  'city.demoUp': '바닥에 올라가서',
  'city.demoDown': '바닥 아래로',
  'city.makeWay.polite': '오, 미안해',
  'city.makeWay.gruff': '어디 가는지 조심해',
  'city.makeWay.immovable': '움직이지 않을 거야',
  'city.makeWay.busy': '길을 조심해',
  'cascade.seoTitle': '캐스케이드 디버거',
  'cascade.title': '캐스케이드 디버거',
  'cascade.intro': '두 가문의 나무로 구성된 예술을 형성하는 모든 명령어. 스타일 측면은 시스템에서 미술 감독까지 진행됩니다. 상속 측면은 모든 분류학입니다. 각 껍데기 뿌리부터 종과 그 위에 앉아있는 혈통까지. 전체 텍스트를 읽을 수있는 모든 줄을 열십시오.',
  'cascade.readOnly': '이 스크린에 있는 어떤 것도 명령어를 바꿀 수 없습니다.',
  'cascade.fetchedAt': '컨텐츠 API에서 읽기 {time}',
  'cascade.refresh': '다시 읽어봐',
  'cascade.loading': '두 물결을 모두 읽다...',
  'cascade.error': '컨텐츠 API에서 캐스케드를 읽을 수 없었어요',
  'cascade.forbidden': '이 화면은 사이트 관리자를 위한 것입니다. 귀하의 계정은 로그인되어 있지만 관리자 역할이 없습니다.',
  'cascade.style.title': '스타일 캐스카드',
  'cascade.style.subtitle': '시스템, 출판사, 제품 라인, 설정, 미디어 유형, 책 및 예술 감독. 각 줄은 그 위에 있는 더 넓은 줄에서 상속됩니다.',
  'cascade.style.focus': '연쇄를 따라',
  'cascade.style.counts': '{nodes} 스타일 라인, {edges} 연결, {media} 미디어 템플릿',
  'cascade.taxa.title': '상속자 계층',
  'cascade.taxa.subtitle': '각 노드는 그 위에 있는 노드에서 물려받은 모든 것에 자신의 프롬프트를 추가합니다.',
  'cascade.taxa.group': '임프트 그룹',
  'cascade.taxa.find': '분류군이나 혈통을 찾아',
  'cascade.taxa.findPlaceholder': '호모, 테라나, 혈통 이름...',
  'cascade.taxa.counts': '{taxa} taxons, {prompts} taxon prompts, {lineages} lineages',
  'cascade.taxa.shardCounts': '{taxa} taxa, {prompts} prompt 라인',
  'cascade.taxa.truncated': '콘텐츠 API는 이 셔드의 프롬프트 리스트를 갱신했습니다. 그래서 여기 몇 줄이 빠질 수도 있습니다.',
  'cascade.taxa.emptyShards': '아직 분류가 없는 덩어리: {names}',
  'cascade.taxa.orphans': '어떤 나무에도 없는 분류군을 가리키는 혈통',
  'cascade.taxa.noOwn': '이 그룹은 별다른 충고를 하지 않습니다.',
  'cascade.taxa.inherits': '위에서 받은 상속',
  'cascade.taxa.inheritsNothing': '물려받은 것은 없습니다. 여기서 사슬이 시작됩니다.',
  'cascade.taxa.through': '이 노드를 통해 구성',
  'cascade.taxa.lineages': '이 종의 혈통',
  'cascade.level.system': '시스템',
  'cascade.level.publisher': '출판사',
  'cascade.level.product_line': '제품 라인',
  'cascade.level.setting': '설정',
  'cascade.level.media': '미디어 유형',
  'cascade.level.book': '책',
  'cascade.level.art_director': '예술감독',
  'cascade.empty.system': '이 사슬에는 시스템 스타일 라인이 없습니다.',
  'cascade.empty.publisher': '아직 출판사 스타일 라인이 없습니다. 이 레벨은 빈 상태입니다.',
  'cascade.empty.product_line': '이 사슬에 제품 라인 스타일 라인이 없습니다.',
  'cascade.empty.setting': '이 사슬에서 스타일 라인을 설정하지 않습니다.',
  'cascade.empty.media': '이 체인에 미디어 타입 템플릿이 적용되지 않습니다.',
  'cascade.empty.book': '책 스타일의 줄은 이 설정에서 달라지지 않습니다.',
  'cascade.empty.art_director': '예술감독은 이 사슬과 연결되어 있지 않습니다.',
  'cascade.missing': '실종 수준',
  'cascade.others': '이 레벨의 다른 행 ({count})',
  'cascade.mediaSpeciesNote': '{count} 종의 템플릿은 후계자 측에서 그들의 혈통 아래로 표시됩니다.',
  'cascade.field.id': 'ID',
  'cascade.field.scope': '적용 범위',
  'cascade.field.scopeId': '범위를 확인',
  'cascade.field.group': '그룹',
  'cascade.field.mediaType': '미디어 타입',
  'cascade.field.prompt': '즉시',
  'cascade.field.negative': '음',
  'cascade.field.defaults': '부적절함',
  'cascade.field.refs': '참조 이미지',
  'cascade.field.chars': '{count} 문자',
  'cascade.field.empty': '빈',
  'cascade.facet.art_direction': '원자력',
  'cascade.facet.art_direction_character': '성격',
  'cascade.facet.art_direction_scene': '장면',
  'cascade.facet.art_direction_interface': '인터페이스',
  'cascade.facet.art_direction_cartography': '카트ोग्राफी',
  'cascade.facet.art_direction_audiobook': '오디오북',
  'cascade.facet.art_direction_movie': '영화',
  'cascade.facet.art_direction_short': '단편',
  'cascade.facet.art_direction_tvshow': 'TV 쇼',
  'cascade.composed.title': '구성된 {name}',
  'cascade.composed.layers': '넓은 층에서 좁은 층',
  'cascade.composed.preview': '복합 이미지 프롬프트',
  'cascade.composed.previewNote': '이 화면에 위의 줄에서 캐스케이드 순서로 구성되어 있습니다. 스타일 코어, 캐릭터 측면, 미디어 템플릿, 분류자 특색, 그 다음 프린트 라인 생성기가 코드를 추가합니다. 라이브 생성기는 프레임 및 주체 텍스트를 추가합니다.',
  'cascade.composed.negative': '합성 음',
  'cascade.composed.fromCode': '코드로 추가된 것, 어떤 행에도 저장되지 않은 것',
  'cascade.flags.duplicates': '두 번이나 말했어',
  'cascade.flags.conflicts': '또한 프롬프트에 나타나는 부정적인 용어',
  'cascade.flags.none': '반복된 문장이나 부정적인 용어가 적지 않은',
  'cascade.flags.in': '에 {sources}',
  'cascade.source.styleCore': '스타일 코어',
  'cascade.source.styleCharacter': '스타일 캐릭터 측면',
  'cascade.source.media': '미디어 템플릿 {scope}',
  'cascade.source.taxon': '분류군 {rank} {value}',
  'cascade.source.printSafe': '인쇄 라인 (코드)',
  'cascade.rank.domain': '도메인',
  'cascade.rank.kingdom': '왕국',
  'cascade.rank.phylum': '필럼',
  'cascade.rank.class': '클래스',
  'cascade.rank.ordem': '순서',
  'cascade.rank.family': '가족',
  'cascade.rank.genus': '종',
  'cascade.rank.species': '종',
  'cascade.rank.shard': '껍데기',
}
